<template>
  <div id="about">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="main">
      <div class="headTit">
        关于我们
        <span @click="Back()" class="backBtn">返回 ></span>
      </div>
      <div class="mainPart">
        <div class="scrollbox" ref="box">
          <ul class="tab">
            <li ref="tabItem" :class="[tabFlag === key? 'active': '']" @click="changeActive(key)"
              v-for="(val, key) in tabList" :key="key">{{val}}</li>
            <!-- <li class="">公司介绍</li>
          <li class="">中消文化</li>
          <li class="">中消大使</li> -->
          </ul>
        </div>

        <div v-if="tabFlag === 0" class="textBody">
          <div class="topbox"></div>
          <p class="detail" v-for="(item,index) in introduce" :key="index">{{item}}</p>
        </div>
        <div v-if="tabFlag === 1" class="textBody">
          <div class="culture"></div>
        </div>
        <div v-if="tabFlag === 2" class="textBody">
          <div class="box">
            <p class="leftP state5">2021年01月</p>
            <p class="rightP line5">中消在线IP《紧急呼叫119》正式启动</p>
          </div>
          <div class="box">
            <p class="leftP state5">2021年01月</p>
            <p class="rightP line5">下陆区政府与消防云签署《智慧消防投资建设运营一体化项目》</p>
          </div>
          <div class="box">
            <p class="leftP state5">2021年01月</p>
            <p class="rightP line5">中集天达四大厂商消防车正式入驻中消商城</p>
          </div>
          <div class="box">
            <p class="leftP state5">2020年11月</p>
            <p class="rightP line5">消防云科技与金盾集团达成《智慧应急安全·智慧消防》领域战略合作</p>
          </div>
          <div class="box">
            <p class="leftP state5">2020年11月</p>
            <p class="rightP line5">中消在线与绿地签署《全面深化战略合作协议》</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年10月</p>
            <p class="rightP line1">消防云与黄石应急管理局正式签署《黄石市智慧消防建设战略合作协议》</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年10月</p>
            <p class="rightP line1">中消在线与华为技术正式签署《应急管理行业消防领域合作协议》</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年05月</p>
            <p class="rightP line1">吉安《智赣 119》“智慧消防”项目正式启动</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年04月</p>
            <p class="rightP line1">中消在线与广州城投佳都智城达成战略合作，共建共营 500 亿智慧消防市场</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年03月</p>
            <p class="rightP line1">中消在线获远大科技 1.1 亿投资</p>
          </div>
          <div class="box">
            <p class="leftP state1">2020年01月</p>
            <p class="rightP line1">中消在线荣获“浙商年度创新企业”称号</p>
          </div>

          <div class="box">
            <p class="leftP state2">2019年11月</p>
            <p class="rightP line2">中消在线与上实融资租赁达成 3 年 90 亿战略合作</p>
          </div>
          <div class="box">
            <p class="leftP state2">2019年10月</p>
            <p class="rightP line2">中消在线中标上海长宁区智慧消防重大管控项目</p>
          </div>
          <div class="box">
            <p class="leftP state2">2019年05月</p>
            <p class="rightP line2">中消在线董事长艾进荣获中国“长三角青商论坛十大新锐青商”称号</p>
          </div>
          <div class="box">
            <p class="leftP state2">2019年01月</p>
            <p class="rightP line2">启动以“浦东机场”及“西安年最中国”为首的应急救援保障项目</p>
          </div>

          <div class="box">
            <p class="leftP state3">2018年11月</p>
            <p class="rightP line3">中消在线应急保障小组首次入驻进博会，为会场提供安全应急保障服务</p>
          </div>
          <div class="box">
            <p class="leftP state3">2018年07月</p>
            <p class="rightP line3">首档以消防急救为题材打造的 IP《紧急呼叫 119》栏目正式上线</p>
          </div>
          <div class="box">
            <p class="leftP state4">2017年11月</p>
            <p class="rightP line4">首次参与并承办 2017 年度中国高层建筑消防安全高峰论坛</p>
          </div>
          <div class="box">
            <p class="leftP state4">2017年06月</p>
            <p class="rightP line4">中消在线成为国际消防技术委员会（CTIF）中国会员单位</p>
          </div>

          <div class="box">
            <p class="leftP state5">2016年06月</p>
            <p class="rightP line5">中消在线总部于上海成立</p>
          </div>
        </div>
        <div v-if="tabFlag === 3" class="textBody">
          <div class="honer" v-for="(item,index) in honerList" :key="index">
            <img :src="item.img" alt="">
            <p class="text">{{item.text}}</p>
          </div>
        </div>
        <div v-if="tabFlag === 4" class="textBody">
          <div class="headIcon"></div>
          <div class="tit">
            <span class="eng">BOUT FOUNDER</span>
            <span class="chin">创始人简介</span>
            <div class="name">艾进</div>
            <p class="detail">
              艾进，1979年10月生于湖北黄石，逸承专项基金发起人；青年书法家；现任中消在线有限公司、消防云（上海）科技有限公司创始人、董事长、上海青联常委、中国青企协会会员、上海青企协会副会长、浙商经济发展中心副主席、楚商联合会理事会第一届常务副会长。2019年荣获中国长三角十大新锐青商称号。
            </p>
            <div class="title">
              人物历程
            </div>
            <p class="detail">
              2014年5月，艾进个人书法全国巡回展首站在黄石市图书馆举行，共展草书、行书、篆书等多种类书法作品20幅。<br>
              2016年，成立上海宋庆龄基金会·逸承专项基金。逸承专项基金是由艾进先生发起，以儿子名字命名，旨在救助先天性肢体残缺病患儿的专项基金。
              同年，创立中消在线(中消在线有限公司)。公司致力于打造消防安全行业标准、消防安全产品行业标准、智慧消防物联网标准
              以及为政府、集团、企业提供“互联网+”一站式技术运营解决方案，促进消防安全模式创新化、科技智能化。<br>
              2018年，创立消防云（上海）科技有限公司。公司全面展开以消防应急安全服务产品为核心的开发工作。<br>
              同年，受邀参加绿地集团华中产业发展联盟峰会，董事长艾进作为大消防行业意见领袖就“消防生态 大有可为”为议题发表演讲。同年11月，董事长艾进作为首届进博会论坛嘉宾，参与贸易与创新平行论坛。<br>
              2019年5月，中消在线董事长艾进出席2019年度中国长三角青商论坛，并获得十大新锐青商称号。<br>
            </p>
            <div class="title">
              社会任职
            </div>
            <p class="detail">
              青年书法家、上海青联常委、中国青企协理事、上海青企协副会长、浙商经济发展中副主席、黄石市楚商联合会理事会常务副会长
            </p>
            <div class="title">
              个人荣誉
            </div>
            <p class="detail">
              2019年 中国长三角青商高峰论坛获得“十大新锐青商”荣誉称号<br>
              2020年 获得黄石市新冠肺炎疫情防控指挥部颁发“疫情无情人有情 捐助家乡暖人心”爱心荣誉
            </p>
            <div class="scrollImg" ref="autoScroll" @touchmove.prevent>
              <img ref="photoItem" v-for="(item,index) in photoList" :src="item" alt="" :key="index" class="photo">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from '../../view/header'
export default {
  components: {
    mainHeader
  },
  data () {
    return {
      tabFlag: 0,
      timmer: '',
      photoList: [require('./images/1.jpg'), require('./images/2.jpg'), require('./images/3.jpg'), require('./images/4.jpg'), require('./images/5.jpg'), require('./images/6.jpg'), require('./images/7.jpg'), require('./images/8.jpg'), require('./images/9.jpg'), require('./images/10.jpg'), require('./images/11.jpg'), require('./images/12.jpg'), require('./images/13.jpg'), require('./images/14.jpg')],
      tabList: ['企业介绍', '企业文化', '发展历程', '企业荣誉', '企业创始人'],
      introduce: [
        '中消在线（中消在线有限公司）于2016年6月成立，总部位于上海，作为中国应急安全服务平台，公司致力于打造消防安全行业标准、消防安全产品行业标准、智慧消防物联网标准以及为政府、集团、企业提供“互联网 +”一站式技术运营解决方案，促进消防安全模式创新化、科技智能化。 ',
        '2017年中消在线组建技术研发团队，全面展开以消防应急安全服务产品为核心的开发工作。现有产品包含七大版块：政府顾问、消防云、在线风险评测、中消商城、应急救援、消防培训、全全APP。 ',
        '2018年推出专注打造“智慧消防”的主力产品 —— 消防云，其核心通过一云（消防云）、二网（5G、NB-IOT）、三平台（大数据平台、物联网平台、运维平台）、N应用为合作载体，发挥“数据驱动”与“云技术”网络协同效应，建立“解决方案+产品+服务”的应急资源服务体系，实现“人防+物防+技防”的安全防控体系，为城市提供全方位应急安全保障。',
        '中消在线是国际消防技术委员会（CTIF）中国会员单位，作为一家技术型企业，中消在线先后与上实集团、京东方、360、广州城投、华为等知名企业达成友好合作关系，实现在品牌、技术、资金多方面强强联合。',
        '未来，公司将以此为契机，全面整合行业大数据信息，为规范社会化应急监督管理服务提供核心价值，建立健全社会生命安全服务体系，进一步运用科技创新技术，推进和完善智慧应急一体化进程，助力国家智慧城市生命安全建设与发展。'
      ],
      honerList: [
        {
          img: require('./images/heighTec.jpg'),
          text: '高新技术企业'
        },
        {
          img: require('./images/CITF.jpg'),
          text: 'CITF 中国会员'
        },
        {
          img: require('./images/hydw.jpg'),
          text: '中国消防协会会员单位'
        },
        {
          img: require('./images/zjnd.jpg'),
          text: '浙商年度创新企业'
        },
        {
          img: require('./images/csjsd.jpg'),
          text: '长三角青商论坛十大新锐青商'
        }
      ]
    }
  },
  beforeCreate () {
    window.scroll(0, 0)
  },
  beforeDestroy () {
    clearInterval(this.timmer)
  },
  methods: {
    logoutClick: function () {
      // this.$router.push({path: 'home'})
    },
    changeActive (index) {
      let Pdom = this.$refs.box
      if (index < this.tabFlag) {
        Pdom.scrollLeft = Pdom.scrollLeft - this.$refs.tabItem[index].offsetWidth
      } else {
        Pdom.scrollLeft = Pdom.scrollLeft + this.$refs.tabItem[index].offsetWidth
      }
      this.tabFlag = index
      if (this.tabFlag == 4) {
        setTimeout(() => {
          this.scrollImg()
        }, 2000)
      } else {
        clearInterval(this.timmer)
      }
    },
    Back () {
      window.history.go(-1)
    },
    scrollImg () {
      let dom = this.$refs.autoScroll
      this.timmer = setInterval(() => {
        if (dom.scrollLeft < this.$refs.photoItem[0].offsetWidth + 10) {
          dom.scrollLeft++
        } else {
          let item = this.photoList.shift()
          this.photoList.push(item)
          dom.scrollLeft = 0
        }
      }, 20)
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.main {
  font-size: 0;
  margin-top: 55px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  .headTit {
    background: #ffffff;
    padding: 0 14px 0 14px;
    line-height: 50px;
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 10px solid #f4f4f4;
    .backBtn {
      font-size: 13px;
      color: #999999;
      float: right;
      font-weight: normal;
    }
  }
  .mainPart {
    width: 100%;
    background: #ffffff;
    overflow-x: hidden;
    .scrollbox {
      width: auto;
      overflow-x: scroll;
      white-space: nowrap;
      border-bottom: 1px solid #eeeeee;
      .tab {
        display: inline-block;
        height: 54px;
        line-height: 54px;
        width: 100%;
        padding: 0 15px 0 15px;
        li {
          position: relative;
          display: inline-block;
          // width: 60px;
          font-size: 13px;
          color: #808080;
          margin-right: 15px;
          margin-left: 15px;
        }
        li:first-child {
          margin-left: 0px;
        }
        li::after {
          content: "";
          position: absolute;
          display: inline-block;
          height: 3px;
          width: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          top: calc(100% - 11px);
        }
        li.active {
          font-size: 15px;
          color: #0e050a;
          font-weight: bold;
        }
        li.active::after {
          content: "";
          position: absolute;
          display: inline-block;
          height: 4px;
          border-radius: 40px;
          width: 26.5px;
          background: #cccccc;
          transition: all 0.3s;
        }
      }
    }
    .scrollbox::-webkit-scrollbar {
      display: none;
    }

    .textBody {
      padding: 18px 15px 30px 15px;
      .topbox {
        width: 100%;
        height: 100px;
        margin-bottom: 23px;
        background: url("./images/top.jpg") no-repeat center center;
        background-size: 100% 100%;
      }
      .title {
        line-height: 50px;
        font-size: 18px;
        color: #323232;
        text-align: center;
        margin-bottom: 27px;
        .img {
          display: inline-block;
          width: 60px;
          height: 50px;
          background: url("./images/logo.png") no-repeat center center;
          background-size: cover;
          margin-right: 15px;
          vertical-align: middle;
        }
        .red {
          color: #c41335;
        }
      }
      .detail {
        font-size: 13px;
        color: #323232;
        margin-bottom: 30px;
        line-height: 24px;
      }
      .culture {
        display: inline-block;
        width: 100%;
        height: 194px;
        background: url("./images/culture.jpg") no-repeat center center;
        background-size: cover;
      }
      .box {
        display: table;
        width: 100%;
        height: 35px;
        margin-bottom: 10px;
        white-space: nowrap;
        .leftP {
          width: 72px;
          text-align: center;
          display: table-cell;
          height: 35px;
          line-height: 35px;
          font-size: 12px;
          color: #ffffff;
          vertical-align: top;
        }
        .rightP {
          width: 273px;
          word-break: break-all;
          white-space: normal;
          text-align: left;
          display: table-cell;
          height: 35px;
          line-height: 16px;
          font-size: 12px;
          color: #000000;
          vertical-align: middle;
          padding-left: 10px;
          padding-right: 10px;
        }
        .state1 {
          background: rgba(238, 29, 37, 1);
        }
        .state2 {
          background: rgba(239, 25, 65, 1);
        }
        .state3 {
          background: rgba(237, 19, 90, 1);
        }
        .state4 {
          background: rgba(236, 6, 114, 1);
        }
        .state5 {
          background: rgba(172, 29, 142, 1);
        }

        .line1 {
          background: rgba(238, 29, 37, 0.13);
        }
        .line2 {
          background: rgba(239, 25, 65, 0.13);
        }
        .line3 {
          background: rgba(237, 19, 90, 0.13);
        }
        .line4 {
          background: rgba(236, 6, 114, 0.13);
        }
        .line5 {
          background: rgba(172, 29, 142, 0.13);
        }
      }
      .honer {
        img {
          display: inline-block;
          width: 345px;
          height: 220px;
          margin-bottom: 6px;
        }
        .text {
          text-align: center;
          font-size: 12px;
          color: #808080;
          margin-bottom: 30px;
        }
      }
      .headIcon {
        float: left;
        width: 155px;
        height: 210px;
        margin-right: 18.5px;
        background: url("./images/touxiang.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .tit {
        font-size: 13px;
        color: #323232;
        line-height: 24px;
        .eng {
          display: block;
          color: #bebebe;
          line-height: 12px;
          font-size: 12px;
          margin-bottom: 8px;
        }
        .chin {
          display: block;
          color: #c41335;
          font-size: 16px;
          line-height: 16px;
          margin-bottom: 18.5px;
          font-weight: bold;
        }
        .name {
          font-size: 16px;
          color: #000000;
          font-weight: bold;
          line-height: 16px;
          margin-bottom: 13px;
        }
        .title {
          font-size: 16px;
          color: #000000;
          line-height: 16px;
          text-align: left;
          margin: 0 0 5px 0;
        }
        .detail {
          font-size: 14px;
          color: #323232;
          line-height: 0.61rem;
          margin-bottom: 30px;
        }
        .scrollImg {
          white-space: nowrap;
          margin-bottom: 36px;
          overflow-x: scroll;
          .photo {
            display: inline-block;
            width: 243px;
            height: 181px;
            margin-right: 10px;
          }
          // .scrollAnimate {
          //   animation: squize 5s infinite;
          // }
          // @keyframes squize {
          //   0% {
          //     width: 243px;
          //   }
          //   100% {
          //     width: 0;
          //   }
          // }
        }
        .scrollImg::-webkit-scrollbar {
          display: none;
        }
      }
      //     <div class="tit">
      // <span class="eng">BOUT FOUNDER</span>
      // <span class="chin">创始人简介</span>
      // <p class="detail">
      // <p class="title">
      //   <i class="img"></i>中国<span class="red">应急</span>安全<span class="red">服务</span>平台
      // </p>
      // <p class="detail" v-for="(item,index) in introduce" :key="index">{{item}}</p>
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about/aboutUs.vue